export const REPORT_DATA_MODEL_VERSION = 1;
export const REPORT_SECTION_ORDER = [
    "cover",
    "business_registration",
    "plan_setup",
    "people_training",
    "suppliers_allergens",
    "temperatures",
    "process_records",
    "cleaning_maintenance",
    "problems",
    "internal_checks",
    "photos",
];
